export class Error {
  constructor(){
      this.fieldValidationErrors = new Array<FieldValidationError>();
  }
  errorCode: number
  message: string
  fieldValidationErrors: Array<FieldValidationError> 
  canDisplayMessageToUser: boolean
}

export class FieldValidationError {
  field: string
  validationMessage: string
}